import {
  DELETE_DEVELOPER_REQUEST,
  DELETE_DEVELOPER_REQUEST_FAILURE,
  DELETE_DEVELOPER_REQUEST_SUCCESS,
  GET_DEVELOPER_REQUESTS,
  GET_DEVELOPER_REQUESTS_FAILURE,
  GET_DEVELOPER_REQUESTS_SUCCESS,
  GET_SINGLE_DEVELOPER_REQUEST,
  GET_SINGLE_DEVELOPER_REQUEST_FAILURE,
  GET_SINGLE_DEVELOPER_REQUEST_SUCCESS,
} from "./actionTypes";

export const getDeveloperRequests = () => {
  return {
    type: GET_DEVELOPER_REQUESTS,
  };
};

export const getDeveloperRequestsSuccess = (country) => {
  return {
    type: GET_DEVELOPER_REQUESTS_SUCCESS,
    payload: country,
  };
};

export const getDeveloperRequestsFailure = (error) => {
  return {
    type: GET_DEVELOPER_REQUESTS_FAILURE,
    payload: error,
  };
};

export const getSingleDeveloperRequest = (id) => {
  return {
    type: GET_SINGLE_DEVELOPER_REQUEST,
    payload: id,
  };
};

export const getSingleDeveloperRequestSuccess = (country) => {
  return {
    type: GET_SINGLE_DEVELOPER_REQUEST_SUCCESS,
    payload: country,
  };
};

export const getSingleDeveloperRequestFailure = (error) => {
  return {
    type: GET_SINGLE_DEVELOPER_REQUEST_FAILURE,
    payload: error,
  };
};

export const deleteDeveloperRequest = (id) => {
  return {
    type: DELETE_DEVELOPER_REQUEST,
    payload: id,
  };
};

export const deleteDeveloperRequestSuccess = (id) => {
  return {
    type: DELETE_DEVELOPER_REQUEST_SUCCESS,
    payload: id,
  };
};

export const deleteDeveloperRequestFailure = (error) => {
  return {
    type: DELETE_DEVELOPER_REQUEST_FAILURE,
    payload: error,
  };
};
